import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    filters: {
      canceled: 'Cancelled',
      done: 'Executed',
      pending: 'Pending',
      processing: 'Processing',
    },
  },
  fr: {
    filters: {
      canceled: 'Annulés',
      done: 'Executés',
      pending: 'En attente',
      processing: 'En traitement',
    },
  },
} as const);
